var React = require('react');

function CogIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"cog","d":"M18.1 10c0-1.2.8-2.2 1.9-2.9-.2-.7-.5-1.4-.8-2-1.3.3-2.3-.2-3.2-1.1s-1.2-1.9-.8-3.2c-.6-.3-1.3-.6-2-.8-.7 1.2-1.9 1.9-3.1 1.9-1.3 0-2.6-.7-3.2-1.9-.7.2-1.4.5-2 .8.3 1.3.1 2.3-.8 3.2-.9.9-2 1.4-3.3 1.1-.3.6-.6 1.3-.8 2 1.2.7 1.9 1.7 1.9 2.9s-.7 2.5-1.9 3.1c.2.7.5 1.4.8 2 1.3-.3 2.3-.1 3.2.8.9.9 1.2 1.9.8 3.2.6.3 1.3.6 2 .8.7-1.2 1.9-1.9 3.1-1.9 1.2 0 2.5.8 3.1 1.9.7-.2 1.4-.5 2-.8-.3-1.3-.1-2.3.8-3.2.9-.9 1.9-1.4 3.2-1.1.3-.6.6-1.3.8-2-1-.6-1.7-1.6-1.7-2.8zM10 14.3c-2.4 0-4.3-1.9-4.3-4.3S7.6 5.7 10 5.7s4.3 1.9 4.3 4.3-1.9 4.3-4.3 4.3z"}));
}

CogIcon.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = CogIcon;

CogIcon.default = CogIcon;
